import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTransition, animated } from "react-spring";

import HeaderPageTitle from "../../../layouts/inc/HeaderPageTitle";
import useTranslations from "../../../i18n/useTranslations";
import { usePageContent } from "../../../i18n/useContentMap";

import {
  partnerList,
  deletePartner,
} from "../../../services/Api/Module/Customer";

import CardPartner from "../../../components/card/CardPartner";
import ModalAlertDeletePartner from "../../../components/modal/ModalAlertDeletePartner";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const MyPartner = ({ renderPartners }) => {
  let height = 0;

  const transitions = useTransition(
    renderPartners.map((data) => ({
      ...data,
      y:
        (height += data.props.curHeight ? data.props.curHeight + 16 : 146) -
        (data.props.curHeight ? data.props.curHeight + 16 : 146),
    })),
    {
      key: (item) => item.key,
      from: { height: 0, opacity: 0, transform: "translateY(30px)" },
      enter: ({ y, height }) => ({
        y,
        height,
        opacity: 1,
        transform: "translateY(0)",
      }),
      leave: { height: 0, opacity: 0, transform: "translateY(30px)" },
      update: ({ data, y, height }) => ({ data, y, height }),
    }
  );

  return (
    <div
      className="item-group"
      style={{ position: "relative", height: height, width: "100%" }}
    >
      {transitions((style, item, t, index) => (
        <animated.div
          className="item-partner"
          style={{
            ...style,
            zIndex: renderPartners.length - index,
            willChange: "transform, height, opacity",
          }}
        >
          {item}
        </animated.div>
      ))}
    </div>
  );
};

const PartnerList = () => {
  const stateProfile = useSelector((state) => state.profile);

  const { t, lang, getCurrentLanguageName } = useTranslations();
  const content = usePageContent("profile");

  const [rawPartners, setRawPartners] = useState([]);
  const [renderPartners, setRenderPartners] = useState([]);

  /* Handle goto page */
  const navigate = useNavigate();

  const handleGotoPage = (e) => {
    e.preventDefault();
    // console.log("click GotoPage", e.currentTarget.dataset.page);

    const page = e.currentTarget.dataset.page;
    navigate("/" + page);
  };
  /* End Handle goto page */

  /* Handle sort */
  const [sortValue, setSortValue] = useState("");

  const handleOnSortChange = (e) => {
    // console.log("handleOnSortChange >>", e.target.value);

    setSortValue(e.target.value);
  };
  /* End Handle sort */

  /* Modal alert delete partner */
  const [deletePartnerId, setDeletePartnerId] = useState(null);
  const [isModalAlertDeletePartnerShow, setIsModalAlertDeletePartnerShow] =
    useState(false);

  const handleCloseModalAlertDeletePartner = (alertDeletePartner) => {
    setIsModalAlertDeletePartnerShow(false);
  };

  const handleConfirmModalAlertDeletePartner = (confirmDeletePartner) => {
    setIsModalAlertDeletePartnerShow(false);

    // console.log("confirmDeletePartner >>", confirmDeletePartner);
    // console.log("deletePartnerId >>", deletePartnerId);
    if (confirmDeletePartner === true) {
      postDeletePartner({
        data: {
          partnerId: deletePartnerId,
        },
        custId: stateProfile.id,
      })
        .then((_rsData) => {
          // console.log("_rsData >>", _rsData);

          if (_rsData.status === true) {
            setRawPartners((prevPartners) =>
              prevPartners.filter((partner) => partner.props.dataPartner.id !== deletePartnerId)
            );
            setRenderPartners((prevPartners) =>
              prevPartners.filter((partner) => partner.props.dataPartner.id !== deletePartnerId)
            );
          } else {
            console.error("ERR in deletePartner:", _rsData);
          }
        })
        .catch((error) => {
          console.error("ERR in deletePartner:", error);
        });
    }
  };
  /* End Modal alert delete partner */

  /* Handle delete partner */
  const handleDeletePartner = (id) => {
    // console.log("handleDeletePartner >>", id);

    setDeletePartnerId(id);
    setIsModalAlertDeletePartnerShow(true);
  };
  /* End Handle delete partner */

  const getPartnerList = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await partnerList({
        custId: payload.custId,
      });
      if (data.resultCode === 20200) {
        const resData = data.body;
        // console.log("getPartnerList resData >>", resData);

        _return.status = true;
        _return.result = resData;
      }
    } catch (e) {
      console.log("ERR getPartnerList >> ", e);
    }

    return _return;
  };

  const postDeletePartner = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await deletePartner({
        data: payload.data,
        custId: payload.custId,
      });
      if (data.resultCode === 20204) {
        const resData = data.body;
        // console.log("postDeletePartner resData >>", resData);

        _return.status = true;
        _return.result = resData;
      } else {
        console.error("ERR in deletePartner:", data);
      }
    } catch (e) {
      console.log("ERR postDeletePartner >> ", e);
    }

    return _return;
  };

  /* First event render */
  const [isLoading, setIsLoading] = useState(true);

  const [initItem, setInitItem] = useState([]);
  const [initHeight, setInitHeight] = useState([]);
  const [curHeight, setCurHeight] = useState([]);

  useEffect(() => {
    // console.log("useEffect !", stateProfile);

    if (Object.getOwnPropertyNames(stateProfile.dataUser).length === 0) {
      navigate("/");
    } else {
      getPartnerList({
        custId: stateProfile.id,
      })
        .then((_rsData) => {
          // console.log("_rsData >>", _rsData);

          if (_rsData.status === true) {
            if (_rsData.result.length > 0) {
              const _length = _rsData.result.length;
              const _partner = _rsData.result;
              // console.log(_partner);
              for (let i = 0; i < _length; i++) {
                setInitItem((prevInitItem) => [...prevInitItem, _partner[i]]);
                setInitHeight((prevCurHeight) => [...prevCurHeight, 0]);
              }
            }
          }

          setIsLoading(false);
        })
        .catch((error) => {
          console.error("ERR in getPartnerList:", error);
        });
    }
  }, []);
  /* End First event render */

  /* Set new height on resize */
  let _tmpHeight = [];

  const setNewHeight = (index, height) => {
    // console.log(index, height, _tmpHeight);
    if (height !== 0) {
      _tmpHeight[index] = height;
      setCurHeight(_tmpHeight);
    }
  };
  /* End Set new height on resize */

  useEffect(() => {
    // console.log(initItem.length, initItem);

    if (initItem.length > 0) {
      for (let i = 0; i < initItem.length; i++) {
        setRawPartners((prevRawPartners) => [
          ...prevRawPartners,
          <CardPartner
            key={i + 1}
            index={i}
            setNewHeight={setNewHeight}
            curHeight={initHeight[i]}
            dataPartner={initItem[i]}
            handleDelete={() => handleDeletePartner(initItem[i].id)}
          />,
        ]);

        _tmpHeight[i] = initHeight[i];
      }
    }
  }, [initItem]);

  useEffect(() => {
    if (rawPartners) {
      // console.log("rawPartners >>", rawPartners.length, rawPartners);
      // console.log("sortValue >>", sortValue);

      let _tmpItem = rawPartners;

      if (sortValue === "2") {
        _tmpItem = [...rawPartners].sort((a, b) =>
          a.props.dataPartner.fullname.localeCompare(
            b.props.dataPartner.fullname
          )
        );
      } else if (sortValue === "3") {
        _tmpItem = [...rawPartners].sort(
          (a, b) =>
            Number(a.props.dataPartner.id) - Number(b.props.dataPartner.id)
        );
      } else {
        // Reset to original order when sortValue is empty
        _tmpItem = [...rawPartners];
      }

      setRenderPartners(_tmpItem);
    }
  }, [rawPartners, sortValue]);

  useEffect(() => {
    // console.log(curHeight.length, curHeight);

    if (curHeight.length > 0) {
      curHeight.map((val, idx) => {
        setRawPartners((prevRawPartners) =>
          prevRawPartners.with(
            idx,
            <CardPartner
              key={rawPartners[idx].key}
              index={idx}
              setNewHeight={setNewHeight}
              curHeight={val}
              dataPartner={rawPartners[idx].props.dataPartner}
              handleDelete={() => handleDeletePartner(rawPartners[idx].props.dataPartner.id)}
            />
          )
        );
      });
    }
  }, [curHeight]);

  // useEffect(() => {
  //   console.log("rawPartners >>", rawPartners.length, rawPartners);
  // }, [isLoading, renderPartners]);

  return (
    <>
      <Helmet>
        <title>Paypoint</title>
        <meta name="title" content="Paypoint" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="Paypoint" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Paypoint" />
      </Helmet>

      <div id="pageMemberlist">
        <main>
          <div className="wrapContent">
            <HeaderPageTitle title={content.title} prevPage="/profile" />

            <section id="pMemberList">
              <div className="bMemberList">
                <div className="bTitle">
                  <h2>
                    พาร์ทเนอร์ <span>({rawPartners.length})</span>
                  </h2>
                  <div className="bFilter">
                    <div className="bFilterItem">
                      <select defaultValue="" onChange={handleOnSortChange}>
                        <option value="" disabled>
                          เรียงตาม
                        </option>
                        <option value="2">ตัวอักษร</option>
                        <option value="3">ลำดับ</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="bMemberListWrap">
                  {isLoading ? (
                    <div className="bNoData">
                      <p>
                        <FontAwesomeIcon icon={faSpinner} spin /> Loading...
                      </p>
                    </div>
                  ) : (
                    <>
                      {renderPartners.length > 0 ? (
                        <MyPartner renderPartners={renderPartners} />
                      ) : (
                        <div className="bNoData">
                          <p>ไม่พบข้อมูล พาร์ทเนอร์ ของคุณ</p>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </section>
          </div>

          <ModalAlertDeletePartner
            open={isModalAlertDeletePartnerShow}
            onClose={(closeDeletePartner) =>
              handleCloseModalAlertDeletePartner(closeDeletePartner)
            }
            onConfirm={(confirmDeletePartner) =>
              handleConfirmModalAlertDeletePartner(confirmDeletePartner)
            }
          />
        </main>
      </div>
    </>
  );
};

export default PartnerList;
